import { get } from "lodash";
import type { Control, FieldPath, FieldValues } from "react-hook-form";
import { useFormState } from "react-hook-form";

/**
 * Inline validation message for a nested field on create/edit contact (email, phone, address, …)
 * after the main form submit fails.
 */
export function ContactFieldRowError<T extends FieldValues>({
  control,
  fieldPath,
}: {
  control: Control<T>;
  fieldPath: FieldPath<T>;
}) {
  const { errors } = useFormState({ control });
  const err = get(errors, fieldPath) as { message?: string } | undefined;
  const message = err?.message;
  if (!message) {
    return null;
  }
  return (
    <p className="text-destructive mt-1.5 text-sm" role="alert">
      {message}
    </p>
  );
}
